import request from '../../api/request';

/**
 * SURVEYS DRAFT SECTION
 */
const SECTION_SCHEDULE = {
  GET_CLASSROOM_AVAILABILITY: `/lessons/get-classroom-availability`,
};

export async function getClassroomAvailability(params: any) {
  return request<any[]>(SECTION_SCHEDULE.GET_CLASSROOM_AVAILABILITY, {
    params,
  });
}
